import React, { FC } from 'react';
import RcDrawer from 'rc-drawer';
import { DrawerProps } from 'common/drawer/drawer.types';
import { DrawerPresets } from 'common/drawer/drawer.presets';
import { Box } from 'common/box';

export const Drawer: FC<DrawerProps> = props => {
  const {
    children,
    className,
    closeButton,
    closeButtonContainerClassName,
    drawerClassName,
    drawerHandler,
    open,
    placement,
    toggleHandler,
    width,
    ...rest
  } = { ...DrawerPresets, ...props };

  return (
    <>
      <RcDrawer
        className={`drawer ${className || ''}`.trim()}
        duration="0.4s"
        handler={false}
        level={null}
        open={open}
        placement={placement}
        width={width}
        onClose={toggleHandler}
        {...rest}>
        {closeButton && (
          <Box as="div" className={closeButtonContainerClassName} onClick={toggleHandler}>
            {closeButton}
          </Box>
        )}
        <Box className={drawerClassName}>{children}</Box>
      </RcDrawer>
      <Box className="drawer__handler" style={{ display: 'inline-block' }} onClick={toggleHandler}>
        {drawerHandler}
      </Box>
    </>
  );
};

export default Drawer;
